import { render, staticRenderFns } from "./ViewCompany.vue?vue&type=template&id=16bf8d34&scoped=true"
import script from "./ViewCompany.vue?vue&type=script&lang=js"
export * from "./ViewCompany.vue?vue&type=script&lang=js"
import style0 from "./ViewCompany.vue?vue&type=style&index=0&id=16bf8d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf8d34",
  null
  
)

export default component.exports